import React, { useEffect, useState } from 'react'
import Logout, { AnnouncementIcon, AssignmentIcon, HelpIcon, InfoIcon, LockIcon, MailIcon, QuestionAnswerIcon, Spordia } from '../../../../utils/icons';
import { DeleteForever } from '@material-ui/icons';
import Tour from '../../../Tour/Tour';
import { contactUsEmail, feedbackEmail, version } from '../../../../utils/constantInformation';
import { signOut } from '../../../../utils/utils';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { signoutRequest } from '../../../../redux/GameInformation/GameInformationAction';
import { TOUR_STEPS } from '../../../Tour/steps/MainScreenStepsLg';
import { TOUR_STEPS_MOB } from '../../../Tour/steps/MainScreenStepsMob';

const goToTerms = () => {
    window.location.href = "https://spontasy.com/terms";
};
const goToPrivacy = () => {
    window.location.href = "https://spontasy.com/privacypolicy";
};

function gotoExternalLink(link) {
    window.open(link);
}
const goToFAQ = () => {
    const path = window.location.origin + "/#faq";
    window.open(path);
};

function handleEmailClient(subject, ideas_flag) {
    let to_email = null;
    if (ideas_flag == true) {
        to_email = feedbackEmail;
    } else {
        to_email = contactUsEmail;
    }
    window.location.href = "mailto:" + to_email + "?subject=" + subject;
}

const Settings = (props) => {

    async function handlesignOut() {
        console.log("-- Handle Sign out called --");
        console.log("State Reset");
        await signOut();
        props.reset_state();
        window.location.href = "/";
    }
    function handleRequestDeletion() {
        console.log("Handle Request Deletion called");
        browserHistory.push("/app/deleteaccount");
    }
    return (
        <div
            className="modal fade"
            id="staticBackdropUserProfile"
            data-backdrop="staticUserProfile"
            tabindex="-1"
            role="dialog"
            aria-labelledby="staticBackdropLabelUserProfile"
            aria-hidden="true"
        >
            <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
            >
                <div className="modal-content">
                    <div className="modal-header d-flex bg-dark text-center text-white lead">
                        <span>Hi {props.userEmail}</span>
                        <button
                            type="button"
                            className="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="bg-black">
                        <ul class="list-group m-2">
                            <li
                                class="d-flex list-group-item bg-dark text-white"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                data-dismiss="modal"
                                style={{ cursor: "pointer" }}
                            >
                                <Tour steps={props.tourSteps}>
                                    <span className="align-items-center align-self-center ml-2">
                                        Walkthrough
                                    </span>
                                </Tour>
                            </li>
                        </ul>

                        <ul class="list-group m-2">
                            <li
                                class="d-flex list-group-item bg-dark text-white"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                style={{ cursor: "pointer" }}
                                data-toggle="collapse"
                                data-target="#collapseExample"
                                aria-expanded="false"
                                aria-controls="collapseExample"
                            >
                                <HelpIcon className="text-primary align-items-center align-self-center mr-2" />
                                <span className="align-items-center align-self-center ml-2">
                                    Feedback & Support
                                </span>
                            </li>
                            <div class="collapse" id="collapseExample">
                                <ul class="list-group m-2">
                                    <li
                                        class="d-flex list-group-item bg-dark text-white"
                                        onClick={goToFAQ}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <QuestionAnswerIcon className="text-primary align-items-center align-self-center mr-3" />
                                        <span className="align-items-center align-self-center">
                                            Frequently Asked Questions
                                        </span>
                                    </li>

                                    <li
                                        class="d-flex list-group-item bg-dark text-white"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            handleEmailClient("Ideas and Suggestions", true);
                                        }}
                                    >
                                        <AnnouncementIcon className="text-primary align-items-center align-self-center mr-3" />
                                        <span className="align-items-center align-self-center">
                                            Ideas & Suggestions
                                        </span>
                                    </li>
                                    <li
                                        class="d-flex list-group-item bg-dark text-white"
                                        onClick={() => {
                                            handleEmailClient("Feedback", false);
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <MailIcon className="text-primary align-items-center align-self-center mr-3" />
                                        <span className="align-items-center align-self-center">
                                            Contact Us
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </ul>

                        <ul class="list-group m-2">
                            <li
                                class="d-flex list-group-item bg-dark text-white"
                            >
                                <Spordia className="align-items-center align-self-center" />
                                <span className="align-items-center align-self-center">
                                    Developed By Spordia Softech Pvt Ltd
                                </span>
                            </li>
                            <li class="list-group-item bg-dark text-white d-flex ">
                                <InfoIcon className="text-primary align-items-center align-self-center mr-3" />
                                <div className="d-flex justify-content-between w-100">
                                    <span className="align-items-center align-self-center">
                                        App Version{" "}
                                    </span>
                                    <span className="lead">
                                        <small>{version}</small>
                                    </span>
                                </div>
                            </li>
                            <li
                                class="d-flex list-group-item bg-dark text-white"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    goToTerms();
                                }}
                            >
                                <AssignmentIcon className="text-primary align-items-center align-self-center mr-3" />
                                <span className="align-items-center align-self-center">
                                    Terms of Use
                                </span>
                            </li>
                            <li
                                class="d-flex list-group-item bg-dark text-white"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    goToPrivacy();
                                }}
                            >
                                <LockIcon className="text-primary align-items-center align-self-center mr-3" />
                                <span className="align-items-center align-self-center">
                                    Privacy Policy
                                </span>
                            </li>
                        </ul>

                        <ul class="list-group m-2">
                            <li
                                class="d-flex list-group-item bg-dark text-white"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                data-dismiss="modal"
                                onClick={handlesignOut}
                                style={{ cursor: "pointer" }}
                            >
                                <Logout className=" align-items-center align-self-center mr-3" />
                                <span className="align-items-center align-self-center ml-2">
                                    Sign out
                                </span>
                            </li>
                        </ul>

                        <ul class="list-group m-2">
                            <li
                                class="d-flex list-group-item bg-dark text-white"
                                aria-label="Large"
                                aria-describedby="inputGroup-sizing-sm"
                                data-dismiss="modal"
                                onClick={handleRequestDeletion}
                                style={{ cursor: "pointer" }}
                            >
                                <DeleteForever className=" align-items-center align-self-center mr-3 text-danger" />
                                <span className="align-items-center align-self-center ml-2">
                                    Request Account Deletion
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div class="modal-footer bg-black">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}


const mapDispatchToProps = (dispatch) => {
    return {
        reset_state: () => dispatch(signoutRequest())
    }
};

export default connect(null, mapDispatchToProps)(Settings)
